module.exports = __webpack_public_path__ + "img/trofeu.svg";